import { AsyncMetaState, createScopedReducer } from '@mews/framework';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import {
    CUSTOMER_DETAIL_INIT_STARTED,
    CUSTOMER_DETAIL_INIT_SUCCEEDED,
    CUSTOMER_DETAIL_INIT_FAILED,
    CUSTOMER_DETAIL_TAB_CHANGED,
    CUSTOMER_DETAIL_INITIALIZED,
} from '../actionTypes';
import { CustomerDetailTabs } from '../enums';

interface CustomerDetailState {
    activeTab: CustomerDetailTabs;
    meta: AsyncMetaState;
    initialized: boolean;
}

export const initialState: CustomerDetailState = {
    activeTab: CustomerDetailTabs.Profile,
    initialized: false,
    ...META_STATE_SUCCEEDED,
};

const init = createScopedReducer(initialState, {
    [CUSTOMER_DETAIL_INITIALIZED]: (state: CustomerDetailState) => ({
        ...state,
        initialized: true,
    }),
    [CUSTOMER_DETAIL_TAB_CHANGED]: (state: CustomerDetailState, activeTab: CustomerDetailTabs) => ({
        ...state,
        activeTab,
    }),
    ...createEntityAsyncMetaHandlers({
        STARTED: CUSTOMER_DETAIL_INIT_STARTED,
        SUCCEEDED: CUSTOMER_DETAIL_INIT_SUCCEEDED,
        FAILED: CUSTOMER_DETAIL_INIT_FAILED,
    }),
});

export default init;
